import { ReactNode } from "react";

import { useAppSelector } from "src/redux/hooks";
import {
    getUserIsSnackpassEmployee,
    getUserSnackpassPermissionsStoreIds,
} from "src/redux/selectors";
import { NotAdminPage } from "#utility-pages/not-admin-of-store-page";

export const StoreAccessGate = ({ children }: { children: ReactNode }) => {
    const isSnackpassEmployee = useAppSelector(getUserIsSnackpassEmployee);
    const storeIds = useAppSelector(getUserSnackpassPermissionsStoreIds);

    if (!isSnackpassEmployee && storeIds.length === 0) {
        return <NotAdminPage />;
    }

    return <>{children}</>;
};
